import { createStore } from 'vuex';
// import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';
import Api from '@/api'
const debug = process.env.NODE_ENV !== 'production';

const notify = async (type, message) => {
  const { useToast } = await import('vue-toastification')
  const toast = useToast()

  toast[type](message)
}

export default createStore({
  state: () => ({
    auth: {
      authorized: false,
      userRole: '',
      user: null,
    },
    isLoading: false,
    errorMessage: '',
    ebooks: '',
    lastModified: null,
    lang: 'zh',
  }),
  getters: {
    user: (state) => state.auth.user,
    account: (state) => state.auth.user?.name,
    authorized: (state) => state.auth.authorized,
    userRole: (state) => state.auth.userRole,
    ebooks: (state) => state.ebooks,
    isLoading: (state) => state.isLoading,
    errorMessage: (state) => state.errorMessage,
    lastModifiedTime: (state) => state.lastModified,
    getDateTime: () => {
      const thisYear = new Date().getFullYear();
      const beginYear = 2014;
      const gap = thisYear - beginYear - 5;
      return Array.from({ length: 10 + gap }, (_, i) => beginYear + i);
    },
    lang: (state) => state.lang
  },
  actions: {
    async isLoading({ commit }, data) {
      commit('ISLOADING', data)
    },
    async setLang({ commit }, lang) {
      commit('SET_LANG', lang)
    },
    updateLoading({ commit }, status) {
      commit('SET_LOADING', status);
    },
    async login({ commit, dispatch }, user) {
      try {
        const { data } = await Api.post('/login', {
          email: user.account,
          password: user.password,
        });
        commit('LOGIN', data);
        await dispatch('getProfile');
        return true
      } catch (err) {
        console.error('Login failed:', err);
        return false;
      }
    },
    async useTokenLogin({ commit, dispatch }, token) {
      const loginToken = { access_token: token, expires_in: 28800, token_type: 'bearer' };
      commit('LOGIN', loginToken);
      await dispatch('getProfile');
    },
    async getProfile({ commit }) {
      const { data } = await Api.get('/user/me');
      commit('UPDATE_PROFILE', data);
    },
    async logout({ commit }) {
      try {
        await Api.post('/logout');
      } catch {
        // Fallback in case of logout failure
      } finally {
        commit('LOGOUT');
        window.location.href = '/adminlogin';
      }
    },
    async dataPost({ commit }, jsonData) {
      try {
        const response = await Api.post('/ebooks/', {
          id: jsonData.id,
          data: jsonData.data,
        });
        await notify('success', 'Save!')
        commit('SET_LAST_MODIFIED', Date.parse(response.data['last-modified']));
      } catch (error) {
        await notify('error', error)
      }
    },
    async dataPatch({ commit }, jsonData) {
      try {
        const response = await Api.patch(`/ebooks/${jsonData.id}`, {
          data: jsonData.data,
        });
        await notify('success', 'Save!')
        commit('SET_LAST_MODIFIED', Date.parse(response.data['last-modified']));
      } catch (error) {
        await notify('error', '存檔錯誤!')
      }
    },
    async refreshToken() {
      const { data } = await Api.get('/user/token/refresh');
      localStorage.setItem('qrCodeToken', data.access_token);
      window.location.reload();
    },
  },
  mutations: {
    ISLOADING(state, status) {
      state.isLoading = status;
    },
    LOGIN(state, data) {
      state.auth.authorized = true;
      state.auth.user = data;
      localStorage.setItem('qrCodeToken', data.access_token);
    },
    UPDATE_PROFILE(state, data) {
      state.auth.userRole = data.role;
      state.auth.user = {
        id: data.id,
        email: data.email,
        name: data.name,
      };
    },
    LOGOUT(state) {
      state.auth.authorized = false;
      state.auth.user = null;
      state.auth.userRole = '';
      localStorage.removeItem('qrCodeToken');
    },
    SET_ERROR_MESSAGE(state, message) {
      state.errorMessage = message;
    },
    SET_LAST_MODIFIED(state, timestamp) {
      state.lastModified = timestamp;
    },
    SET_LANG(state, lang) {
      state.lang = lang;
    },
  },
  modules: {},
  strict: debug,
  plugins: [createPersistedState({ paths: ['auth'] })],
});
